import React from 'react';
import { Base, Typography } from 'lib/cortiUI';
export const LegendItem = ({ color, label }) => {
    return (React.createElement(Base, { display: "flex", gap: 3, alignItems: "center" },
        React.createElement(Base, { background: color, borderRadius: "50%", height: 6, width: 6 }),
        React.createElement(Typography, null, label)));
};
